var _rect, _circle, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimePending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEF0CA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_2912",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#002953"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_2912)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.668 8.02051V10.2705C10.668 11.2435 11.1163 12.1629 11.8828 12.7578H11.8838L15.7197 15.7344L16 15.9521L16.2812 15.7344L20.1162 12.7578L20.1172 12.7588L20.1279 12.749L20.248 12.6514L20.2578 12.6426C20.9385 12.0479 21.332 11.1828 21.332 10.2705V8.02051H22.1875V10.2705C22.1875 11.4394 21.6821 12.5452 20.8135 13.3037L20.6367 13.4502L17.1719 16.1377L16.7051 16.5L17.1719 16.8623L20.6367 19.5498L20.8252 19.7051C21.6874 20.4634 22.1875 21.5653 22.1875 22.7295V24.9795H9.8125V22.7295C9.8125 21.483 10.3869 20.3083 11.3643 19.5498L14.8271 16.8623L15.2939 16.5L14.8271 16.1377L11.3643 13.4502C10.3869 12.6916 9.8125 11.5169 9.8125 10.2705V8.02051H10.668Z",
    fill: "#E4CA79",
    stroke: "#BF9100",
    strokeWidth: 0.916667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1045 7.5625C23.6108 7.5625 24.0212 7.97291 24.0212 8.47917C24.0212 8.98542 23.6108 9.39583 23.1045 9.39583H8.89616C8.3899 9.39583 7.97949 8.98542 7.97949 8.47917C7.97949 7.97291 8.3899 7.5625 8.89616 7.5625H23.1045Z",
    fill: "#BF9100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1045 23.6041C23.6108 23.6041 24.0212 24.0145 24.0212 24.5208C24.0212 25.0271 23.6108 25.4375 23.1045 25.4375H8.89616C8.3899 25.4375 7.97949 25.0271 7.97949 24.5208C7.97949 24.0145 8.3899 23.6041 8.89616 23.6041H23.1045Z",
    fill: "#BF9100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePending);
export default __webpack_public_path__ + "static/media/timePending.97770e0437d892af2b400531c6929129.svg";
export { ForwardRef as ReactComponent };